
























































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch, Inject } from "vue-property-decorator";
import { IPromotionItemModel } from "../../models";
import { ModelState } from "@elite/validation";
import { RestClient } from "@elite/restclient";
import PromotionManagementEvents from "./PromotionManagementEvents";

@Component
export default class PromotionLineItemModal extends Vue {
    @Inject()
    restClient!: RestClient;

    @Inject()
    modelState!: ModelState;

    @Prop({ required: false, type: Number, default: null })
    promotionId!: number | null;

    @Prop({ required: false, type: Number, default: 0 })
    id!: number;

    @Prop({ required: true, type: Boolean })
    value!: boolean;

    model: IPromotionItemModel | null = null;

    get localValue(): boolean {
        return this.value;
    }
    set localValue(value: boolean) {
        this.$emit("input", value);
    }

    async saveClicked(): Promise<void> {
        if (!this.model) {
            return;
        }

        const response = await this.restClient.postJson(
            "/api/PromotionItem",
            this.model
        );

        if (this.modelState.hasErrors(response)) {
            this.modelState.addResponseErrors(response, this);
            return;
        }

        this.$root.$emit(
            PromotionManagementEvents.promotionItemGridRefreshEvent
        );
        this.localValue = false;
    }

    @Watch("value")
    @Watch("id")
    async resetModel(): Promise<void> {
        if (this.id === 0) {
            if (!this.promotionId) {
                return;
            }

            this.model = {
                id: 0,
                externalId: null,
                name: null,
                price: 0,
                shippingPrice: 0,
                sortOrder: null,
                promotionId: this.promotionId,
                choiceCode: null
            };
        } else {
            const response = await this.restClient.getJson<IPromotionItemModel>(
                `/api/PromotionItem/${this.id}`
            );

            if (response.status !== 200 || !response.data) {
                this.localValue = false;
            } else {
                this.model = response.data;
            }
        }
    }
}
